export default "__VITE_ASSET__DAU2UR3t__"